import * as React from 'react';
import PropTypes from 'prop-types';
import {
	Button,
	Confirm,
	Dimmer,
	Form,
	Icon,
	Image,
	Loader,
	Message,
	Pagination,
	Popup,
	Segment,
	Card as SemanticCard
} from "semantic-ui-react";
import {Subbar, Title, Sortable, SearchFilter, ItemCountSelector, PageHeader} from "ah-tools";
import {translate} from "react-i18next";
import {makeRoute, ROUTE_KFZ, ROUTE_KFZ_MODEL, ROUTE_KFZ_MODEL_CREATE} from "../routes";
import {
	Card,
	CardHeader,
	CardText,
	Table, TableBody,
	TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter
} from "material-ui";
import CarIcon from 'material-ui/svg-icons/maps/directions-car';
import {sort, sortDefault, sortNum} from "ith-sort";
import {compare, compareDefault} from "ith-compare";
import {LOC_KFZ_MODEL_LIST} from "../actions";
import {COLOR_PRIMARY, IMAGE_URL} from "../misc/vars";
import naImage from '../images/not-available.jpg';
import {IconButton, FormLabel} from "../extensions";
// import isFunc from 'lodash/isFunction';

const filterOptions = [
	{key: 'type', text: 'Typbezeichnung', value: 'type'},
	{key: 'hsn-tsn', text: 'HSN/TSN', value: 'hsn-tsn'},
	{key: 'tsn', text: 'TSN', value: 'tsn'}
];

const sortOptions = [
	{key: 'hsn-tsn-asc', order: 'ascending', title: 'HSN/TSN aufsteigend'},
	{key: 'hsn-tsn-desc', order: 'descending', title: 'HSN/TSN absteigend'},
	{key: 'tsn-asc', order: 'ascending', title: 'TSN aufsteigend'},
	{key: 'tsn-desc', order: 'descending', title: 'TSN absteigend'},
	{key: 'type-asc', order: 'ascending', title: 'Typ aufsteigend'},
	{key: 'type-desc', order: 'descending', title: 'Typ absteigend'},
	{key: 'fromYear-asc', order: 'ascending', title: 'von Baujahr aufsteigend'},
	{key: 'fromYear-desc', order: 'descending', title: 'von Baujahr absteigend'},
	{key: 'tillYear-asc', order: 'ascending', title: 'bis Baujahr aufsteigend'},
	{key: 'tillYear-desc', order: 'descending', title: 'bis Baujahr absteigend'},
	{key: 'ps-asc', order: 'ascending', title: 'PS aufsteigend'},
	{key: 'ps-desc', order: 'descending', title: 'PS absteigend'},
	{key: 'ccm-asc', order: 'ascending', title: 'CCM aufsteigend'},
	{key: 'ccm-desc', order: 'descending', title: 'CCM absteigend'},
	
];

const fromStorage = () => JSON.parse(window.localStorage.getItem(LOC_KFZ_MODEL_LIST)) || ({
	filter: filterOptions[0].key,
	text: '',
	order: sortOptions[0].key,
	count: 10
});

class KfzEdit extends React.Component {
	static propTypes = {
		kfz_id: PropTypes.number,
		kfz: PropTypes.object,
		models: PropTypes.array,
		push: PropTypes.func.isRequired,
		onSave: PropTypes.func.isRequired,
		isUpdating: PropTypes.bool,
		onDelete: PropTypes.func,
		onModelDelete: PropTypes.func,
		onUploadLogo: PropTypes.func.isRequired,
		isUploading: PropTypes.bool
	};
	static defaultProps = {
		kfz: null,
		models: [],
		kfz_id: null,
		isUpdating: false,
		onDelete: (kfz, callback) => {},
		onModelDelete: (kfz_id, hsn, tsn, callback) => {},
		onUploadLogo: () => alert('onUploadLogo() is not implemented'),
		isUploading: false
	};
	state = {
		kfz: {
			kfz_id: undefined,
			name: '',
			models: []
		},
		present: fromStorage(),
		_filter: {
			filter: filterOptions[0].key,
			text: ''
		},
		page: 0,
		editable: false,
		confirmDelete: false,
		confirmModelDelete: null,
		logo: null,
		preview: null,
		origin_logo: null
	};
	
	setLogo = logo => {
		if ( logo ) {
			logo = `${IMAGE_URL}${logo.ident}.${logo.origin_extension}?${logo.updated_at}`;
		}
		this.setState({preview: logo, origin_logo: logo, logo: null});
	};
	
	handleLogoSelection = ({target: {files}}) => {
		const logo = files && files.length ? files[0] : null;
		this.setState({logo});
		if ( logo && 'FileReader' in window ) {
			const reader = new FileReader();
			reader.onload = ({target:{result: preview}}) => this.setState({preview});
			reader.readAsDataURL(logo);
		} else {
			this.setState({preview: this.state.origin_logo});
		}
	};
	
	updatePresent = (index, value, root = {}) => this.setState(state => ({
		...state,
		...root,
		present: {
			...state.present,
			[index]: value
		}
	}));
	
	updateFilter = (index, value, root = {}) => this.setState(state => ({
		...state,
		...root,
		_filter: {
			...state._filter,
			[index]: value
		}
	}));
	
	componentWillMount = () => {
		const {kfz, kfz_id} = this.props;
		this.kfz_id = kfz_id;
		if ( kfz ) {
			this.setLogo(kfz.logo);
			this.setState({kfz});
		}
	};
	
	componentWillUnmount = () => {
		this.kfz_id = null;
	};
	
	componentWillReceiveProps = ({kfz}) => {
		if ( kfz ) {
			this.setLogo(kfz.logo);
			this.setState({kfz});
		}
	};
	
	updateKfz = (index, value, root = {}) => this.setState(state => ({
		...state,
		...root,
		kfz: {
			...state.kfz,
			[index]: value
		}
	}));
	
	editForm = ({kfz_id, name}, create = false, t = this.props.t) => (
		<Form loading={this.props.isUpdating} onSubmit={() => this.props.onSave(this.state.kfz)}>
			<Form.Field>
				<Form.Input required value={name} labelPosition={'left'} label={'Name des Herstellers'} onChange={(_, el) => this.updateKfz('name', el.value)}>
					<FormLabel><CarIcon/></FormLabel>
					<input/>
				</Form.Input>
				{!this.state.confirmDelete && <Form.Field>
					<Subbar align={create ? Subbar.ALIGN_END : Subbar.ALIGN_BETWEEN}>
						{!create && <Button type={'button'} negative inverted onClick={() => this.setState({confirmDelete: true})}>{t('actions.delete')}</Button>}
						<Button type={'submit'} positive inverted>{t('actions.save')}</Button>
					</Subbar>
				</Form.Field>}
				{ this.state.confirmDelete &&
					<Subbar align={Subbar.ALIGN_BETWEEN}>
						<span>Bist du dir sicher?</span>
						<Subbar>
							<Button type={'button'} style={{marginRight: 20}} onClick={() => this.setState({confirmDelete: false})}>{t('actions.no')}</Button>
							<Button type={'button'} negative onClick={() => this.props.onDelete(kfz_id)}>{t('actions.yes')}</Button>
						</Subbar>
					</Subbar>
				}
			</Form.Field>
		</Form>
	);
	
	sorted = () => {
		const option = sortOptions.find(el => el.key === this.state.present.order);
		let _ = option.key.split('-');
		const order = _.pop();
		const key = _.join('-');
		switch(key) {
			case 'hsn-tsn':
				return sort(order)(m => m.hsn + m.tsn);
			case 'tsn':
				return sort(order)(m => m.tsn);
			case 'type':
				return sort(order)(m => m.type);
			case 'fromYear':
				return sortNum(order)(m => m.fromYear);
			case 'tillYear':
				return sortNum(order)(m => m.tillYear || 9999);
			case 'ps':
				return sortNum(order)(m => m.ps);
			case 'ccm':
				return sortNum(order)(m => m.ccm);
			default:
				return sortDefault;
		}
	};
	
	tableTitles = () => {
		return (
			<TableRow>
				<TableHeaderColumn>Typ</TableHeaderColumn>
				<TableHeaderColumn>HSN/TSN</TableHeaderColumn>
				<TableHeaderColumn>Baujahr</TableHeaderColumn>
				<TableHeaderColumn>KW/PS</TableHeaderColumn>
				<TableHeaderColumn>CCM</TableHeaderColumn>
			</TableRow>
		);
	};
	
	pagination = (page = 0, pages = 0) => (pages < 2 ? null :
		<Subbar align={Subbar.ALIGN_CENTER}>
			<Pagination secondary pointing activePage={page+1} totalPages={pages} onPageChange={(_,page) => this.setState({page: page.activePage - 1})} />
		</Subbar>
	);
	
	filtered = () => {
		const {_filter: {text, filter}} = this.state;
		switch(filter) {
			case 'hsn-tsn':
				return compare(text, {fuzzy: false})(model => model.hsn+model.tsn);
			case 'tsn':
				return compare(text, {fuzzy: false})(model => model.tsn);
			case 'type':
				return compare(text)(model => model.type);
			default:
				return compareDefault;
		}
	};
	
	
	render = () => {
		const {kfz, editable, present, _filter, page, confirmModelDelete, preview, logo} = this.state;
		const {t, push, kfz: origin, isUpdating, onModelDelete, onDeleteLogo, onUploadLogo, isUploading} = this.props;
		let list = origin ? origin.models : [];
		list = list.filter(this.filtered());
		const pageIndex = page * present.count;
		const models = list.sort(this.sorted()).slice(pageIndex, pageIndex + present.count);
		window.localStorage.setItem(LOC_KFZ_MODEL_LIST, JSON.stringify(present));
		return (
			<Segment basic>
				<PageHeader>
					<Subbar>
						<IconButton style={{marginRight: 10}} onClick={() => push(ROUTE_KFZ)}><Icon name={'chevron left'} size={'large'}/></IconButton>
						<Title loading={isUpdating}>{this.kfz_id && origin ? `${origin.name} (${origin.kfz_id})` : 'Neuer KFZ-Hersteller'}</Title>
					</Subbar>
				</PageHeader>
				{this.kfz_id ?
					<React.Fragment>
						<Card expanded={editable} onExpandChange={() => this.setState({editable: !editable})}>
							<CardHeader title={<strong><Icon name={'pencil'}/>Bearbeiten</strong>}  actAsExpander showExpandableButton  className={'ith-card-pointer'}/>
							<CardText expandable>
								<Message info content={'Das Ändern der Namen, kann zu Problemen mit dem Import führen.'}/>
								{this.editForm(kfz)}
							</CardText>
						</Card>
						<Card>
							<CardHeader
								title={<strong><Icon name={'image'}/>Logo</strong>}
								actAsExpander
								showExpandableButton
								className={'ith-card-pointer'}
							/>
							<CardText expandable>
								<input
									style={{position: 'absolute', top: -9999999, left: -999999999, width: 1, height: 1, overflow: 'hidden'}}
									type="file"
									id={'logo-upload'}
									accept={'image/png,image/jpg,image/jpeg'}
									onChange={this.handleLogoSelection}/>
								<Subbar>
									<SemanticCard style={{textAlign: 'center'}}>
										<Dimmer active={isUploading}><Loader size={'large'} style={{color: COLOR_PRIMARY}} className={'blue-loader'}><strong>Lade Logo hoch</strong></Loader></Dimmer>
										<Subbar align={Subbar.ALIGN_CENTER} style={{position: 'relative'}}>
											<Image src={preview ? preview : naImage} alt={'Logo'} size={'small'}/>
											{onDeleteLogo && origin.logo_id && <IconButton  onClick={() => onDeleteLogo(origin)} style={{zIndex: 2, position: 'absolute', top: 0, right: 0, background: 'rgba(0,0,150,0.1)', borderRadius: '50%', borderTopRightRadius: '.28571429rem'}}><Icon name={isUpdating ? 'spinner' : 'trash'} loading={isUpdating}/></IconButton>}
										</Subbar>
										<SemanticCard.Content style={{position: 'relative'}}>
											<SemanticCard.Header>Logo-Upload</SemanticCard.Header>
											{logo && <SemanticCard.Meta>{logo.name}</SemanticCard.Meta>}
										</SemanticCard.Content>
										<SemanticCard.Content extra>
											<label htmlFor="logo-upload" className={'ui button'} role={'button'}><Icon name={'image'}/> wählen</label>
											{logo && <Button style={{marginLeft: 15}} positive inverted icon onClick={() => onUploadLogo(origin, logo)}><Icon name={'upload'}/></Button>}
										</SemanticCard.Content>
									</SemanticCard>
								</Subbar>
							</CardText>
						</Card>
					</React.Fragment>
				: this.editForm(kfz, true)}
				{this.kfz_id &&
					<Card>
						<CardHeader>
							<Subbar align={Subbar.ALIGN_BETWEEN}>
								<strong>Modelle</strong>
								<Subbar>
									<ItemCountSelector
										options={[10, 25, 50]}
										selected={present.count}
										onChange={value => this.updatePresent('count', value, {page: 0})}
									/>
									<Sortable
										value={present.order}
										onChange={(_, key, value) => this.updatePresent('order', value)}
										options={sortOptions}
									/>
									<SearchFilter
										value={_filter.text}
										onChange={value => this.updateFilter('text', value, {page: 0})}
										selected={_filter.filter}
										options={filterOptions}
										onSelect={value => this.updateFilter('filter', value)}
									/>
									<Popup content={'Neues Model anlegen'} inverted trigger={
										<IconButton onClick={() => push(makeRoute(ROUTE_KFZ_MODEL_CREATE, {kfz_id: this.kfz_id}))}><Icon name={'plus'} size={'large'}/></IconButton>}/>
								</Subbar>
							</Subbar>
						</CardHeader>
						{models.length && <Segment basic>
							{this.pagination(page, Math.ceil(list.length / present.count))}
							<Table selectable={false} style={{marginBottom: 15}} onCellClick={index => {
								const {kfz_id, hsn, tsn} = models[index];
								push(makeRoute(ROUTE_KFZ_MODEL, {kfz_id, hsn, tsn}));
							}}>
								<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
									{this.tableTitles()}
									</TableHeader>
								<TableBody displayRowCheckbox={false} showRowHover>
									{ models.map(({kfz_id, type, hsn, tsn, ps, kw, ccm, fromYear, tillYear}) =>
										<TableRow key={hsn + tsn}>
											<TableRowColumn>{type}</TableRowColumn>
											<TableRowColumn>{hsn} / {tsn}</TableRowColumn>
											<TableRowColumn>{tillYear ? `${fromYear} - ${tillYear}` : fromYear === tillYear ? fromYear : `ab ${fromYear}`}</TableRowColumn>
											<TableRowColumn>{kw} / {ps}</TableRowColumn>
											<TableRowColumn>
												<Subbar align={Subbar.ALIGN_BETWEEN}>
													{ccm}
													<IconButton onClick={(e) => {
														e.stopPropagation();
														this.setState({confirmModelDelete: () => onModelDelete(kfz_id, hsn, tsn, () => this.setState({confirmModelDelete: null}))})
													}}><Icon name={'trash'} /></IconButton>
												</Subbar>
											</TableRowColumn>
										</TableRow>
									)}
								</TableBody>
								<TableFooter adjustForCheckbox={false}>
									{this.tableTitles(TableFooter)}
								</TableFooter>
							</Table>
							{this.pagination(page, Math.ceil(list.length / present.count))}
						</Segment>}
						{!models.length &&
							<Segment basic padded={'very'}>
								Keine Modele gefunden/vorhanden
							</Segment>
						}
					</Card>
				}
				<Confirm
					open={null !== confirmModelDelete}
					content={t('confirm.sure')}
					cancelButton={t('actions.no')}
					confirmButton={t('actions.yes')}
					onCancel={() => this.setState({confirmModelDelete: null})}
					onConfirm={() => confirmModelDelete()}/>
			</Segment>
		);
	}
}

export default translate()(KfzEdit);


// WEBPACK FOOTER //
// ./src/components/KfzEdit.js